export function getBody () {
  var doc = document,
      body = doc.body;

  if (!body) {
    body = doc.createElement('body');
    body.fake = true;
  }

  return body;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/getBody.js
// module id = 1
// module chunks = 0